module.exports = __webpack_public_path__ + "img/16.729e6911.jpg";